module.exports = __webpack_public_path__ + "static/media/Maie Burke Headshot.231e3f26.jpeg";